import * as LucideIcons from "lucide-react";

interface Service {
  icon?: any;
  icon_name?: string;
  title: string;
  description: string;
}

interface ServicesSectionProps {
  services?: Service[];
}

const defaultServices: Service[] = [
  {
    icon: "Share2",
    title: "SOCIAL MEDIA MARKETING",
    description:
      "Strategic campaigns across all platforms to build your brand and engage audiences effectively.",
  },
  {
    icon: "Globe",
    title: "DIGITAL DISTRIBUTION",
    description:
      "Get your content distributed across major platforms including Spotify, Apple Music, and more.",
  },
  {
    icon: "Megaphone",
    title: "ONLINE PROMOTION",
    description:
      "Targeted promotional campaigns that drive real engagement and increase your digital footprint.",
  },
  {
    icon: "FileText",
    title: "CONTENT MARKETING",
    description:
      "Compelling content strategies that tell your story and connect with your target audience.",
  },
  {
    icon: "Youtube",
    title: "YOUTUBE PROMOTIONS",
    description:
      "Maximize your YouTube reach with targeted ads, SEO optimization, and viral strategies.",
  },
  {
    icon: "Instagram",
    title: "INFLUENCER MARKETING",
    description:
      "Connect with top influencers to amplify your brand message and reach new audiences.",
  },
];

export function ServicesSection({ services }: ServicesSectionProps) {
  const displayServices = services && services.length > 0 ? services : defaultServices;

  return (
    <section id="services" className="py-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <p className="text-primary font-medium tracking-[0.2em] uppercase mb-4">
            What We Offer
          </p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-foreground mb-6">
            SERVICES WE CAN HELP
            <span className="block text-gradient-gold">YOU WITH</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {displayServices.map((service, index) => {
            // Dynamically get the icon component
            const iconName = service.icon_name || service.icon;
            // @ts-ignore
            const IconComponent = LucideIcons[iconName] || LucideIcons.HelpCircle;

            return (
              <div
                key={service.title}
                className="group relative p-8 rounded-xl bg-gradient-card border border-border/50 hover-lift hover-glow cursor-pointer"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="w-16 h-16 rounded-lg bg-gradient-gold flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <IconComponent size={28} className="text-primary-foreground" />
                </div>
                <h3 className="font-display text-2xl text-foreground mb-4 group-hover:text-primary transition-colors">
                  {service.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  {service.description}
                </p>
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-gold scale-x-0 group-hover:scale-x-100 transition-transform duration-500 rounded-b-xl" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
